import { Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Roles from "./pages/Roles";
import Users from "./pages/Users";
import UserDetail from "./pages/UserDetail";
import Workflows from "./pages/Workflows";
import AuditLogs from "./pages/AuditLogs";
import { UserProfile } from "./pages/UserProfile";
import { Settings } from "./pages/Settings";
import { MasterData } from "./pages/MasterData";
import CreatePassword from "./pages/CreatePassword";
import WeddingApply from "./pages/WeddingApply";
import WeddingApproval from "./pages/WeddingApproval";
import WeddingPrint from "./pages/WeddingPrint";
import WeddingFinalize from "./pages/WeddingFinalize";
import WeddingReprint from "./pages/WeddingReprint";
import ApprovalDetail from "./pages/ApprovalDetail";
import WeddingApplicationDetail from "./pages/WeddingApplicationDetail";
import DivorceApplicationDetail from "./pages/DivorceApplicationDetail";
import MarriageCertDetail from "./pages/MarriageCertDetail";
import CertificatePrint from "./pages/CertificatePrint";
import CertificatePrintSigned from "./pages/CertificatePrintSigned";
import MobileMoneyPayment from "./pages/MobileMoneyPayment";
import DivorceApply from "./pages/DivorceApply";
import DivorceApproval from "./pages/DivorceApproval";
import DivorcePrint from "./pages/DivorcePrint";
import DivorceReprint from "./pages/DivorceReprint";
import UsersManual from "./pages/UsersManual";
import { PageTitleProvider } from "./contexts/PageTitleContext";

const App = () => {
  return (
    <PageTitleProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/reset-password/create-password"
          element={<CreatePassword />}
        />
        <Route
          path="/reset-password/create-password/reset-password"
          element={<CreatePassword />}
        />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/marriages/apply" element={<WeddingApply />} />
        <Route path="/marriages/approval" element={<WeddingApproval />} />
        <Route path="/marriages/approval/:id" element={<ApprovalDetail />} />
        <Route path="/marriages/print" element={<WeddingPrint />} />
        <Route path="/marriages/reprint" element={<WeddingReprint />} />
        <Route path="/marriages/print/:id" element={<CertificatePrint />} />
        <Route path="/marriages/finalize" element={<WeddingFinalize />} />
        <Route
          path="/marriages/finalize-print/:id"
          element={<CertificatePrintSigned />}
        />
        <Route
          path="/marriages/finalize/:id"
          element={<MarriageCertDetail />}
        />
        <Route
          path="/marriages/apply/:id"
          element={<WeddingApplicationDetail />}
        />
        <Route path="/payments/mobile-money" element={<MobileMoneyPayment />} />
        <Route path="/divorce/apply" element={<DivorceApply />} />
        <Route
          path="/divorce/apply/:id"
          element={<DivorceApplicationDetail />}
        />
        <Route path="/divorce/approval" element={<DivorceApproval />} />
        <Route
          path="/divorce/approval/:id"
          element={<DivorceApplicationDetail />}
        />
        <Route path="/divorce/print" element={<DivorcePrint />} />
        <Route
          path="/divorce/print/:id"
          element={<DivorceApplicationDetail />}
        />
        <Route path="/divorce/reprint" element={<DivorceReprint />} />
        <Route path="/admin/roles" element={<Roles />} />
        <Route path="/admin/users" element={<Users />} />
        <Route path="/admin/users/:id" element={<UserDetail />} />
        <Route path="/admin/workflows" element={<Workflows />} />
        <Route path="/admin/audit-logs" element={<AuditLogs />} />
        <Route path="/admin/settings" element={<Settings />} />
        <Route path="/admin/master-data" element={<MasterData />} />
        <Route path="/users-manual" element={<UsersManual />} />
      </Routes>
    </PageTitleProvider>
  );
};

export default App;
